// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2_SqO","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__fY8GK"};